<template>
    <div>
        <div class="mb-8 flex justify-between items-start md:-mx-4">
            <div class="md:w-2/3 md:px-4">
                <h3>For Product</h3>
                <button
                    v-for="(cat, index) in productCategories"
                    :key="cat+index"
                    class="btn btn-blue mt-4"
                    :disabled="selected.product_category == cat && searchQuery == ''"
                    :title="selected.product_category == cat ? '' : `View “${cat}” product category gold certification holders`"
                    @click="select(cat, 'product_category')"
                >{{ cat }}</button>
                <h3 class="mt-4">For Installation</h3>
                <button
                    v-for="(cat, index) in installationCategories"
                    :key="cat+index"
                    class="btn btn-blue mt-4"
                    :disabled="selected.installation_category == cat && searchQuery == ''"
                    :title="selected.installation_category == cat ? '' : `View “${cat}” installation category gold certification holders`"
                    @click="select(cat, 'installation_category')"
                >{{ cat }}</button>
            </div>
            <div class="md:w-1/3 md:px-4">
                <div class="white-card">
                    <h3 class="mb-3">Search</h3>
                    <div class="input">
                        <input type="text" v-model="searchQuery" placeholder="Start typing..." />
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-4 flex flex-wrap -mx-4" v-if="visibleCertificationHolders.length > 0">
            <div
                v-for="(cert_holder, index) in visibleCertificationHolders"
                :key="cert_holder.id+index"
                class="px-4 w-1/2 md:w-1/3 lg:w-1/4 mb-8"
            >
                <gold-certification-holder :cert_holder="cert_holder" />
            </div>
        </div>
        <div
            class="py-12 flex flex-col justify-center items-center text-center leading-loose"
            v-else
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                class="w-6 h-6 fill-current opacity-50 mb-4"
            >
                <path
                    d="M0 10a10 10 0 1 1 20 0 10 10 0 0 1-20 0zm16.32-4.9L5.09 16.31A8 8 0 0 0 16.32 5.09zm-1.41-1.42A8 8 0 0 0 3.68 14.91L14.91 3.68z"
                />
            </svg>
            <span class="text-sm">No results to display</span>
            <button
                @click="clearSearchQuery"
                class="btn btn-white mt-8"
                v-if="searchQuery"
            >Clear Search Query</button>
        </div>
    </div>
</template>

<script>
import GoldCertificationHolder from "./GoldCertificationHolder";
export default {
    components: {
        GoldCertificationHolder
    },
    data() {
        return {
            cert_holders: [],
            selected: {
                installation_category: "",
                product_category: ""
            },
            searchQuery: ""
        };
    },
    mounted() {
        axios.get("/gold-certification-holders.json").then(response => {
            this.cert_holders = response.data.data;
            this.selected.product_category = this.productCategories[0];
        });
    },
    methods: {
        getUniqueSortedValues(key) {
            return [
                ...new Set(
                    this.cert_holders.map(cert_holder => cert_holder[key])
                )
            ]
                .filter(el => { return el != "" && el != null})
                .sort((x, y) => {
                    let first = "Kitchen";
                    return x == first ? -1 : y == first ? 1 : 0;
                });
        },
        select(val, type) {
            this.clearSearchQuery();
            this.selected.installation_category = "";
            this.selected.product_category = "";
            this.selected[type] = val;
        },
        clearSearchQuery() {
            this.searchQuery = "";
        }
    },
    computed: {
        installationCategories() {
            return this.getUniqueSortedValues("installation_category");
        },
        productCategories() {
            return this.getUniqueSortedValues("product_category");
        },
        visibleCertificationHolders() {
            if (this.searchQuery != "") {
                return this.certificationHoldersBasedOnSearchQuery;
            } else {
                return this.certificationHoldersBasedOnCategory;
            }
        },
        certificationHoldersBasedOnCategory() {
            return this.cert_holders
                .filter(cert_holder => {
                    if (this.selected.installation_category) {
                        return (
                            cert_holder.installation_category ==
                            this.selected.installation_category
                        );
                    }
                    if (this.selected.product_category) {
                        return (
                            cert_holder.product_category ==
                            this.selected.product_category
                        );
                    }
                })
                .sort((a, b) =>
                    a.title > b.title ? 1 : b.title > a.title ? -1 : 0
                );
        },
        certificationHoldersBasedOnSearchQuery() {
            return this.cert_holders.filter(cert_holder => {
                let queryableData = cert_holder.title;
                queryableData += cert_holder.product_category;
                queryableData += cert_holder.installation_category;
                queryableData += cert_holder.profile_url;

                return queryableData
                    .toLowerCase()
                    .includes(this.searchQuery.toLowerCase());
            });
        }
    }
};
</script>

<style>
</style>
